export default __webpack_public_path__ + "static/media/a4_landscape.5d0dadf1.png";